import { Stack, useTheme } from "@fluentui/react";
import React from "react";
import { getVersionComponentTextContainerStyle } from "./VersionComponentTextContainer.styles";
export const VersionComponentTextContainer = ({ children, marginBottom = 0 }) => {
    const theme = useTheme();
    return (React.createElement(Stack, { horizontal: true, verticalAlign: "center", styles: getVersionComponentTextContainerStyle(theme, marginBottom), tokens: {
            childrenGap: 9,
            padding: 12,
        } }, children));
};
